/**
 * 文档上传格式统一工具。
 *
 * 支持：.pdf / .docx / .txt / .md / .csv / .json / .xml / .yaml / .yml
 * 不支持旧版 .doc（Word 97-2003 OLE 二进制，后端无法解析）。
 *
 * 校验一律按「扩展名」而非 file.type/MIME——不同浏览器/OS 对 .md/.docx
 * 的 MIME 识别不一致（常为空或 application/octet-stream），按 MIME 白名单
 * 会误拦合法文件、误放 .doc。
 */

// <input accept> 属性值，供所有文档上传入口复用
export const DOCUMENT_ACCEPT = '.pdf,.docx,.txt,.md,.csv,.json,.xml,.yaml,.yml';

// 支持的文档扩展名（不含前导点，小写）
export const DOCUMENT_EXTENSIONS = ['pdf', 'docx', 'txt', 'md', 'csv', 'json', 'xml', 'yaml', 'yml'];

/** 从文件名取小写扩展名（不含点）；无扩展名返回空串 */
export function getFileExtension(name: string): string {
  const idx = name.lastIndexOf('.');
  return idx >= 0 ? name.slice(idx + 1).toLowerCase() : '';
}

/** 按扩展名判断是否为支持的文档格式 */
export function isSupportedDocumentFile(file: File): boolean {
  return DOCUMENT_EXTENSIONS.includes(getFileExtension(file.name));
}
